import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import BlockTimeForm from './blockTimeForm';
import { addBlockTime } from '../../barbers/actions';
import { getAll, getFirstBarberId } from '../../barbers/selector';
import { getDate } from '../appointmentSelector';
import config from '../../../../config';
import confirmModal from '../../../common/confirmModal';
import { CONFIRMATION_REQUIRED_STATUS } from '../../constants';

const mapStateToProps = (state, props) => ({
  barbers: getAll(state),
  initialValues: {
    day: getDate(state),
    startTime: props.start ? props.start.format(config.timeFormat) : '12:00 pm',
    endTime: props.end ? props.end.format(config.timeFormat) : '12:15 pm',
    barberId: props.barberId || getFirstBarberId(state),
  },
});

const mapDispatchToProps = {
  saveBlockTime: addBlockTime,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    save: props => data => new Promise((resolve, reject) =>
      props.saveBlockTime(data).then(resolve).catch((err) => {
        if (err.status === CONFIRMATION_REQUIRED_STATUS) {
          return confirmModal(
            {
              title: 'Heads up!',
              message: err.message,
              type: 'yesno',
              confirmButtonText: 'Yes',
              negativeButtonText: 'No',
            },
            () => props.saveBlockTime(data, true).then(resolve),
            () => resolve(null),
          );
        }

        return reject(err);
      })
    ),
    afterSave: props => (data) => {
      if (!data) {
        return null;
      }

      return props.afterSave(data);
    },
  })
)(BlockTimeForm);
